// Add this debounce function at the beginning of your file
function debounce(func, wait) {
  let timeout;
  return function executedFunction(...args) {
    const later = () => {
      clearTimeout(timeout);
      func(...args);
    };
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
  };
}

const elements = {
  menuButton: document.getElementById('menu-button'),
  closeButton: document.getElementById('close-menu'),
  menu: document.getElementById('menu'),
  overlay: document.getElementById('overlay'),
  addToCartForm: document.getElementById('add-to-cart-form'),
  sizeSelect: document.getElementById('size-select'),
  addToCartButton: document.getElementById('add-to-cart-btn'),
  colorOptions: document.querySelector('.color-options'),
};

let productSplide;
let lastValidImageIndex = 0;

// Reusable functions
const toggleMenu = (menuElement, open) => {
  const translateClass = menuElement === elements.menu ? '-translate-x-full' : 'translate-x-full';
  menuElement.classList.toggle(translateClass, !open);
  elements.overlay.classList.toggle('opacity-0', !open);
  elements.overlay.classList.toggle('pointer-events-none', !open);
  document.body.style.overflow = open ? 'hidden' : '';
};

const fetchCartData = () => fetch('/cart.js').then(response => response.json());

const updateCart = (cart) => {
  updateMainCart(cart);
  updateCartCount(cart.item_count);
};

const updateCartContents = () => {
  console.log('Fetching cart contents on page load');
  fetch('/cart.js')
    .then(response => response.json())
    .then(cart => {
      console.log('Cart data loaded:', cart);
      updateMainCart(cart);
      updateCartCount(cart.item_count);
    })
    .catch(error => {
      console.error('Error fetching cart contents:', error);
      // If cart fetch fails, hide cart buttons
      updateCartCount(0);
    });
};

const debouncedUpdateCartContents = debounce(updateCartContents, 300);

const updateCartItemElement = (cartItem, item, prefix) => {
  const cartItemElement = cartItem.querySelector('.cart-item');
  cartItemElement.dataset.key = item.key;
  cartItemElement.dataset.unitPrice = item.price;
  
  const img = cartItem.querySelector('img');
  img.src = item.image;
  img.alt = item.title;
  
  const titleLink = cartItem.querySelector('.cart-item-title-link');
  titleLink.href = item.url;
  titleLink.textContent = item.product_title;
  
  const variantTitle = cartItem.querySelector('.cart-item-variant');
  if (item.variant_title && item.variant_title !== 'Default Title') {
    variantTitle.textContent = item.variant_title;
  } else {
    variantTitle.remove();
  }
  
  const quantityInput = cartItem.querySelector('.cart-item-quantity-input');
  quantityInput.value = item.quantity;
  quantityInput.dataset.key = item.key;
  quantityInput.id = `${prefix}quantity-${item.key}`;
  
  const price = cartItem.querySelector('.cart-item-price');
  price.textContent = Shopify.formatMoney(item.line_price);
};

const handleCartQuantityChange = (event) => {
  const target = event.target;
  const button = target.closest('.cart-item-quantity-decrease, .cart-item-quantity-increase');
  
  if (button) {
    event.preventDefault();
    const wrapper = button.closest('.cart-item-quantity-wrapper');
    const input = wrapper.querySelector('.cart-item-quantity-input');
    const key = input.dataset.key;
    let quantity = parseInt(input.value);

    if (button.classList.contains('cart-item-quantity-decrease')) {
      quantity = quantity > 1 ? quantity - 1 : 0;
    } else if (button.classList.contains('cart-item-quantity-increase')) {
      quantity += 1;
    }

    input.value = quantity;
    
    // Update price immediately in both main cart and menu cart
    updateItemPrice(key, quantity);
    
    // Update cart on server and refresh totals
    updateCartItemQuantity(key, quantity);
  }
};

const updateItemPrice = (key, quantity) => {
  const cartItems = document.querySelectorAll(`.cart-item[data-key="${key}"]`);
  
  cartItems.forEach(cartItem => {
    const priceElement = cartItem.querySelector('.cart-item-price');
    const unitPrice = parseFloat(cartItem.dataset.unitPrice);
    if (priceElement && !isNaN(unitPrice)) {
      const newPrice = unitPrice * quantity;
      priceElement.textContent = Shopify.formatMoney(newPrice);
    }
    
    const quantityInput = cartItem.querySelector('.cart-item-quantity-input');
    if (quantityInput) {
      quantityInput.value = quantity;
    }
  });

  updateTotalPriceEstimate();
};

const updateTotalPriceEstimate = () => {
  const cartItems = document.querySelectorAll('#cart-items-container .cart-item');
  let totalPrice = 0;

  cartItems.forEach(item => {
    const price = parseFloat(item.dataset.unitPrice);
    const quantity = parseInt(item.querySelector('.cart-item-quantity-input').value);
    totalPrice += price * quantity;
  });

  const cartTotal = document.getElementById('cart-total');
  if (cartTotal) {
    cartTotal.textContent = Shopify.formatMoney(totalPrice);
  }
};

const updateCartItemQuantity = (key, quantity) => {
  fetch('/cart/change.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ id: key, quantity: quantity })
  })
  .then(response => response.json())
  .then(cart => {
    if (quantity === 0) {
      // Remove the item from main cart
      const mainCartItem = document.querySelector(`#cart-items-container .cart-item[data-key="${key}"]`);
      
      if (mainCartItem) mainCartItem.remove();
    }

    // Update cart contents (this will update totals and any discrepancies)
    updateCartContents();

    // Check if cart is empty and update UI accordingly
    if (cart.item_count === 0) {
      updateEmptyCartState();
    }
  })
  .catch(error => console.error('Error updating cart:', error));
};

const updateEmptyCartState = () => {
  const mainCartContainer = document.getElementById('cart-items-container');

  if (mainCartContainer) {
    mainCartContainer.innerHTML = `
      <div class="my-4">Warenkorb ist leer</div>
      <a class="button w-full text-center" href="/">Weitershoppen</a>
    `;
  }

  // Hide checkout buttons and totals
  const checkoutButton = document.querySelector('button[name="checkout"]');
  const additionalCheckoutButtons = document.querySelector('.additional-checkout-buttons');
  const cartTotalContainer = document.querySelector('.cart-total-container');
  const cartNoteSection = document.querySelector('.cart-note-section');

  if (checkoutButton) checkoutButton.style.display = 'none';
  if (additionalCheckoutButtons) additionalCheckoutButtons.style.display = 'none';
  if (cartTotalContainer) cartTotalContainer.style.display = 'none';
  if (cartNoteSection) cartNoteSection.style.display = 'none';
};

const selectColor = (button) => {
  // Remove 'selected' class from all color buttons
  document.querySelectorAll('.color-option').forEach(btn => btn.classList.remove('selected'));
  
  // Add 'selected' class to clicked button
  button.classList.add('selected');
  
  // Get selected color
  const selectedColor = button.getAttribute('data-color');
  
  // Update available sizes based on selected color
  updateAvailableSizes(selectedColor);

  // Check if any sizes are available
  const sizeSelect = document.getElementById('size-select');
  const availableSizes = Array.from(sizeSelect.options).filter(option => !option.disabled && option.value !== "");
  
  const addToCartButton = document.getElementById('add-to-cart-btn');
  if (availableSizes.length === 0) {
    // No sizes available, disable add to cart button
    addToCartButton.textContent = 'Ausverkauft';
    addToCartButton.disabled = true;
  } else {
    // Reset add to cart button
    resetAddToCartButton(addToCartButton);
    // Check availability for current selection
    updateAddToCartButtonAvailability();
  }

  // Find the first available variant with this color and update the image
  const variants = JSON.parse(document.getElementById('product-variants').textContent);
  const selectedVariant = variants.find(variant => variant.options.includes(selectedColor) && variant.available);
  if (selectedVariant) {
    updateProductImage(selectedVariant);
    // Update URL with selected color
    updateURL(selectedColor);
  }

  // Update the size select with the selected color
  if (sizeSelect) {
    sizeSelect.dispatchEvent(new Event('change'));
  }
};

const addToCart = (event) => {
  event.preventDefault();
  
  const form = document.getElementById('add-to-cart-form');
  const colorOptions = document.querySelector('.color-options');
  const sizeSelect = document.getElementById('size-select');
  const addToCartButton = document.getElementById('add-to-cart-btn');
  const productionModelCheckbox = document.getElementById('production-model');
  
  // Check if color selection is required and made
  if (colorOptions) {
    const selectedColor = document.querySelector('.color-option.selected');
    if (!selectedColor) {
      setAddToCartButtonError(addToCartButton);
      return;
    }
  }

  // Check if size selection is required and made
  if (sizeSelect && sizeSelect.value === "") {
    setAddToCartButtonError(addToCartButton);
    return;
  }

  // Check if production model checkbox exists and is required
  if (productionModelCheckbox && addToCartButton.dataset.requiresCheckbox === 'true' && !productionModelCheckbox.checked) {
    addToCartButton.classList.add('btn-error-state');
    addToCartButton.innerHTML = 'Bitte bestätigen';
    return;
  }

  // Reset button appearance if all validations pass
  resetAddToCartButton(addToCartButton);

  // Get selected color and size
  const selectedColor = document.querySelector('.color-option.selected')?.getAttribute('data-color');
  const selectedSize = sizeSelect ? sizeSelect.value : null;

  // Find the correct variant ID based on selected options
  const variantsElement = document.getElementById('product-variants');
  let variants = [];
  
  if (variantsElement) {
    try {
      variants = JSON.parse(variantsElement.textContent);
    } catch (error) {
      console.error('Error parsing product variants:', error);
    }
  }

  let selectedVariant;

  if (variants.length > 0) {
    if (colorOptions && selectedSize) {
      selectedVariant = variants.find(variant => 
        variant.options.includes(selectedColor) && variant.options.includes(selectedSize)
      );
    } else if (colorOptions) {
      selectedVariant = variants.find(variant => 
        variant.options.includes(selectedColor)
      );
    } else if (selectedSize) {
      selectedVariant = variants.find(variant => 
        variant.options.includes(selectedSize)
      );
    } else {
      selectedVariant = variants[0];
    }
  } else {
    // For simple products without variants, get the product availability from the form
    const variantId = form.querySelector('input[name="id"]').value;
    selectedVariant = { 
      id: variantId, 
      available: true // We'll check availability via server response
    };
  }

  if (!selectedVariant) {
    alert('Die gewählte Kombination ist nicht verfügbar');
    return;
  }

  // Check if the selected variant is available
  if (!selectedVariant.available) {
    setAddToCartButtonError(addToCartButton);
    addToCartButton.textContent = 'Ausverkauft';
    return;
  }

  // Update the form data with the correct variant ID
  const formData = new FormData(form);
  formData.set('id', selectedVariant.id);

  // Set loading state
  addToCartButton.textContent = 'Hinzufügen...';
  addToCartButton.disabled = true;

  fetch('/cart/add.js', {
    method: 'POST',
    body: formData
  })
  .then(response => {
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    return response.json();
  })
  .then(data => {
    console.log('Product added to cart:', data);

    // Show the hidden notification with animation
    const notification = document.querySelector('.notification');
    if (notification) {
      notification.classList.add('show');
    }

    // Update the cart contents dynamically
    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        updateMainCart(cart);
        updateCartCount(cart.item_count); // This line updates the cart count
      })
      .catch(error => console.error('Error updating cart contents:', error));
  })
  .catch(error => {
    console.error('Error adding to cart:', error);
    
    // Handle specific error cases
    if (error.message.includes('422') || error.message.includes('Not available')) {
      addToCartButton.textContent = 'Ausverkauft';
      addToCartButton.classList.add('btn-error-state');
      addToCartButton.disabled = true;
    } else {
      addToCartButton.textContent = 'Fehler - Erneut versuchen';
      addToCartButton.classList.add('btn-error-state');
      setTimeout(() => {
        resetAddToCartButton(addToCartButton);
      }, 3000);
    }
  })
  .finally(() => {
    // Only reset button state if no error occurred
    if (!addToCartButton.classList.contains('btn-error-state')) {
      resetAddToCartButton(addToCartButton);
    }
  });
};

// Event listeners setup
const setupEventListeners = () => {
  elements.menuButton.addEventListener('click', () => toggleMenu(elements.menu, true));
  elements.closeButton.addEventListener('click', () => toggleMenu(elements.menu, false));
  elements.overlay.addEventListener('click', () => {
    toggleMenu(elements.menu, false);
  });

  document.addEventListener('click', handleCartQuantityChange);

  if (elements.addToCartForm) {
    elements.addToCartForm.addEventListener('submit', addToCart);
  }

  if (elements.sizeSelect) {
    elements.sizeSelect.addEventListener('change', () => {
      resetAddToCartButton(elements.addToCartButton);
      updateProductImageBasedOnSelection();
      updateAddToCartButtonAvailability();
    });
  }

  if (elements.colorOptions) {
    elements.colorOptions.addEventListener('click', (event) => {
      if (event.target.classList.contains('color-option')) {
        selectColor(event.target);
      }
    });
  }
};

// Header height calculation and CSS variable update
const updateHeaderHeight = () => {
  const header = document.querySelector('.header-scroll');
  if (!header) {
    console.warn('Header with class .header-scroll not found');
    return;
  }

  // Use a small delay to ensure layout is complete
  requestAnimationFrame(() => {
    // Calculate the total height of the header including all sections
    const headerHeight = header.offsetHeight;
    
    // Set the CSS variable with the calculated height
    document.documentElement.style.setProperty('--header-height', `${headerHeight}px`);
    
    console.log(`Header height updated: ${headerHeight}px`);
  });
};

// Setup ResizeObserver to watch for header size changes
const setupHeaderObserver = () => {
  const header = document.querySelector('.header-scroll');
  if (!header) {
    console.warn('Header with class .header-scroll not found for observer');
    return;
  }

  // Create a ResizeObserver to watch for header size changes
  const resizeObserver = new ResizeObserver(debounce(() => {
    updateHeaderHeight();
  }, 100));

  // Start observing the header
  resizeObserver.observe(header);
  
  console.log('Header ResizeObserver initialized');
};



// Smooth scrolling for anchor links with offset
const setupSmoothScrolling = () => {
  // Handle clicks on anchor links
  document.addEventListener('click', function(e) {
    const link = e.target.closest('a[href^="#"]');
    if (!link) return;
    
    const href = link.getAttribute('href');
    if (!href || href === '#') return;
    
    const targetId = href.substring(1);
    const targetElement = document.getElementById(targetId);
    
    if (!targetElement) return;
    
    e.preventDefault();
    
    // Calculate offset based on fixed header and secondary menu
    const headerHeight = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--header-height')) || 112; // 7rem fallback
    const secondaryMenu = document.querySelector('.shopify-section--secondary-menu');
    const secondaryMenuHeight = secondaryMenu ? 48 : 0; // 3rem
    const extraOffset = 16; // 1rem additional padding
    
    const totalOffset = headerHeight + secondaryMenuHeight + extraOffset;
    
    // Get target position
    const targetPosition = targetElement.getBoundingClientRect().top + window.pageYOffset - totalOffset;
    
    // Smooth scroll to target
    window.scrollTo({
      top: Math.max(0, targetPosition),
      behavior: 'smooth'
    });
    
    // Update URL hash after scroll completes
    setTimeout(() => {
      history.pushState(null, null, href);
    }, 100);
  });
  
  console.log('Smooth scrolling for anchors initialized');
};

// FAQ Accordion Animation
const setupFAQAccordion = () => {
  const faqItems = document.querySelectorAll('.faq-item');
  
  faqItems.forEach(item => {
    const summary = item.querySelector('summary');
    const content = item.querySelector('.faq-content');
    const inner = item.querySelector('.faq-inner');
    
    if (!summary || !content || !inner) return;
    
    // Set initial state
    if (!item.open) {
      content.style.maxHeight = '0';
      content.style.paddingBottom = '0';
    } else {
      content.style.maxHeight = inner.scrollHeight + 24 + 'px'; // 24px for pb-6
    }
    
    summary.addEventListener('click', (e) => {
      e.preventDefault();
      
      const isOpen = item.open;
      
      if (isOpen) {
        // Closing animation
        content.style.maxHeight = '0';
        content.style.paddingBottom = '0';
        
        setTimeout(() => {
          item.open = false;
        }, 300);
      } else {
        // Opening animation
        item.open = true;
        
        // Force a reflow to ensure the content is rendered
        const height = inner.scrollHeight;
        
        requestAnimationFrame(() => {
          content.style.maxHeight = height + 24 + 'px'; // 24px for pb-6
          content.style.paddingBottom = '1.5rem'; // pb-6
        });
      }
    });
  });
};

// Initialization
document.addEventListener('DOMContentLoaded', () => {
  console.log('DOM loaded, initializing cart');
  setupEventListeners();
  setupSmoothScrolling();
  setupFAQAccordion();
  selectColorFromURL();
  
  // Calculate and set initial header height
  updateHeaderHeight();
  
  // Update header height on window resize
  window.addEventListener('resize', debounce(updateHeaderHeight, 250));
  
  const cartItemsContainer = document.getElementById('cart-items-container');
  if (cartItemsContainer && !cartItemsContainer.querySelector('#cart-items')) {
    updateCartContents();
  }

  const productionModelCheckbox = document.getElementById('production-model');
  const addToCartButton = document.getElementById('add-to-cart-btn');
  
  if (productionModelCheckbox && addToCartButton) {
    productionModelCheckbox.addEventListener('change', function() {
      if (this.checked) {
        resetAddToCartButton(addToCartButton);
      }
    });
  }

  // Check initial availability state
  updateAddToCartButtonAvailability();
});

// Menu cart functionality removed - cart slide no longer exists

function updateMainCart(cart) {
  const cartItemsContainer = document.getElementById('cart-items-container');
  const cartItemTemplate = document.getElementById('cart-item-template');
  const cartTotal = document.getElementById('cart-total');
  const cartForm = document.querySelector('form[action="/cart"]');
  
  if (cartItemsContainer) {
    // Check if the cart is already populated
    if (cartItemsContainer.querySelector('#cart-items') && cart.items.length > 0) {
      // Cart is already populated, just update quantities and totals
      updateExistingCartItems(cart);
      return;
    }

    cartItemsContainer.innerHTML = '';
    
    if (cart.items.length === 0) {
      // Cart is empty
      cartItemsContainer.innerHTML = `
        <div class="my-4">Warenkorb ist leer</div>
        <a class="button w-full text-center" href="/">Weitershoppen</a>
      `;
      
      // Hide the cart total, checkout button, and other elements
      if (cartTotal) cartTotal.closest('.cart-total-container').style.display = 'none';
      const checkoutButton = cartForm.querySelector('button[name="checkout"]');
      if (checkoutButton) checkoutButton.style.display = 'none';
      
      // Hide additional checkout buttons if they exist
      const additionalCheckoutButtons = cartForm.querySelector('.additional-checkout-buttons');
      if (additionalCheckoutButtons) additionalCheckoutButtons.style.display = 'none';
    } else {
      // Cart has items
      const ul = document.createElement('ul');
      ul.id = 'cart-items';
      ul.className = 'cart-items-list';
      
      cart.items.forEach(item => {
        const cartItem = cartItemTemplate.content.cloneNode(true);
        updateCartItemElement(cartItem, item, 'cart-');
        ul.appendChild(cartItem);
      });
      
      cartItemsContainer.appendChild(ul);
      
      // Show and update the cart total
      if (cartTotal) {
        cartTotal.textContent = Shopify.formatMoney(cart.total_price);
        cartTotal.closest('.cart-total-container').style.display = '';
      }
      
      // Show the checkout button
      const checkoutButton = cartForm.querySelector('button[name="checkout"]');
      if (checkoutButton) checkoutButton.style.display = '';
      
      // Show additional checkout buttons if they exist
      const additionalCheckoutButtons = cartForm.querySelector('.additional-checkout-buttons');
      if (additionalCheckoutButtons) additionalCheckoutButtons.style.display = '';
    }
  }
}

function updateExistingCartItems(cart) {
  cart.items.forEach(item => {
    const cartItem = document.querySelector(`.cart-item[data-key="${item.key}"]`);
    if (cartItem) {
      const quantityInput = cartItem.querySelector('.cart-item-quantity-input');
      if (quantityInput) {
        quantityInput.value = item.quantity;
      }
      updateItemPrices(item.key, item.quantity);
    }
  });

  // Update total
  const cartTotal = document.getElementById('cart-total');
  if (cartTotal) {
    cartTotal.textContent = Shopify.formatMoney(cart.total_price);
  }
}

function updateItemPriceAndTotal(item, newQuantity) {
  const newLinePrice = item.price * newQuantity;
  const cartItem = document.querySelector(`.cart-item[data-key="${item.key}"]`);
  const priceElement = cartItem.querySelector('.cart-item-price');
  priceElement.textContent = Shopify.formatMoney(newLinePrice);

  // Update the total price
  fetch('/cart.js')
    .then(response => response.json())
    .then(cart => {
      const cartTotal = document.getElementById('cart-total');
      if (cartTotal) {
        cartTotal.textContent = Shopify.formatMoney(cart.total_price);
      }
    })
    .catch(error => console.error('Error updating total price:', error));
}


function updateCartCount(count) {
  const cartButtons = document.querySelectorAll('.cart-button');
  const cartCountElements = document.querySelectorAll('.cart-count');
  const cartNotificationCount = document.getElementById('cart-notification-count');
  
  console.log('Updating cart count to:', count);
  
  // Show/hide cart buttons based on count
  cartButtons.forEach(button => {
    if (count > 0) {
      button.style.display = 'block';
    } else {
      button.style.display = 'none';
    }
  });
  
  // Update cart count displays
  cartCountElements.forEach(element => {
    element.textContent = count;
  });
  
  if (cartNotificationCount) {
    cartNotificationCount.textContent = count;
  }
}

// Updated function to update URL
function updateURL(color) {
  if (history.pushState) {
    const formattedColor = color.toLowerCase().replace(/\s+/g, '-');
    const newurl = window.location.protocol + "//" + window.location.host + window.location.pathname + '?color=' + encodeURIComponent(formattedColor);
    window.history.pushState({path:newurl},'',newurl);
  }
}

// Updated function to select color from URL parameter
function selectColorFromURL() {
  const urlParams = new URLSearchParams(window.location.search);
  const color = urlParams.get('color');
  if (color) {
    const formattedColor = color.replace(/-/g, ' ');
    const colorButton = document.querySelector(`.color-option[data-color="${formattedColor}"]`);
    if (colorButton) {
      selectColor(colorButton);
    }
  }
}

function updateAvailableSizes(color) {
  const sizeSelect = document.getElementById('size-select');
  const variants = JSON.parse(document.getElementById('product-variants').textContent);
  
  // Store the current selection
  const currentSelection = sizeSelect.value;

  // Get the original option name
  const originalOptionName = sizeSelect.querySelector('option[value=""]').textContent;
  
  // Clear current options
  sizeSelect.innerHTML = `<option selected disabled value="">${originalOptionName}</option>`;

  // Add size options for the selected color
  const availableSizes = new Set();
  const unavailableSizes = new Set();
  variants.forEach(variant => {
    if (variant.option1 === color || variant.option2 === color) {
      const size = variant.options.find(opt => opt !== color);
      if (variant.available) {
        availableSizes.add(size);
      } else {
        unavailableSizes.add(size);
      }
    }
  });

  // Add available sizes
  availableSizes.forEach(size => {
    const option = document.createElement('option');
    option.value = size;
    option.textContent = size;
    sizeSelect.appendChild(option);
  });

  // Add unavailable sizes (disabled)
  unavailableSizes.forEach(size => {
    if (!availableSizes.has(size)) {
      const option = document.createElement('option');
      option.value = size;
      option.textContent = size + ' - Ausverkauft';
      option.disabled = true;
      sizeSelect.appendChild(option);
    }
  });

  // Restore the previous selection if it's still available
  if (Array.from(sizeSelect.options).some(option => option.value === currentSelection && !option.disabled)) {
    sizeSelect.value = currentSelection;
  } else {
    sizeSelect.value = ""; // Reset to default option if previous selection is not available
  }

  // Find the first available variant with this color and update the image
  const selectedVariant = variants.find(variant => variant.options.includes(color) && variant.available);
  if (selectedVariant) {
    updateProductImage(selectedVariant);
  }
}

// New function to set error state on Add to Cart button
function setAddToCartButtonError(button) {
  button.textContent = 'Bitte wählen';
  button.classList.add('btn-error-state');
  button.disabled = true;
}

// New function to reset Add to Cart button
function resetAddToCartButton(button) {
  button.textContent = 'In den Warenkorb';
  button.classList.remove('btn-error-state');
  button.disabled = false;
}

// Function to check and update add to cart button availability
function updateAddToCartButtonAvailability() {
  const addToCartButton = document.getElementById('add-to-cart-btn');
  if (!addToCartButton) return;

  const colorOptions = document.querySelector('.color-options');
  const sizeSelect = document.getElementById('size-select');
  const variantsElement = document.getElementById('product-variants');
  
  if (!variantsElement) return;

  let variants = [];
  try {
    variants = JSON.parse(variantsElement.textContent);
  } catch (error) {
    console.error('Error parsing product variants:', error);
    return;
  }

  // Get current selections
  const selectedColor = colorOptions ? document.querySelector('.color-option.selected')?.getAttribute('data-color') : null;
  const selectedSize = sizeSelect ? sizeSelect.value : null;

  // Find the current variant based on selections
  let currentVariant;
  
  if (variants.length > 0) {
    if (colorOptions && selectedSize && selectedColor) {
      currentVariant = variants.find(variant => 
        variant.options.includes(selectedColor) && variant.options.includes(selectedSize)
      );
    } else if (colorOptions && selectedColor) {
      currentVariant = variants.find(variant => 
        variant.options.includes(selectedColor)
      );
    } else if (selectedSize) {
      currentVariant = variants.find(variant => 
        variant.options.includes(selectedSize)
      );
    } else {
      currentVariant = variants[0];
    }

    // Check if current variant is available
    if (currentVariant && !currentVariant.available) {
      addToCartButton.textContent = 'Ausverkauft';
      addToCartButton.disabled = true;
      addToCartButton.classList.add('btn-error-state');
    } else if (currentVariant && currentVariant.available) {
      resetAddToCartButton(addToCartButton);
    }
  }
}

function closeNotification() {
  const notification = document.querySelector('.notification');
  if (notification) {
    notification.classList.remove('show');
  }
}

Shopify.formatMoney = function(cents, format = "€{{amount}}") {
  var value = (cents / 100).toFixed(2).replace('.', ',');
  return format.replace("{{amount}}", value);
};

function findVariantImageIndex(variant) {
  const variantImage = variant.featured_image;
  if (!variantImage) {
    return -1;
  }

  const imagesElement = document.getElementById('product-images');
  if (!imagesElement) {
    return -1;
  }

  const images = JSON.parse(imagesElement.textContent);


  // Try to find an exact match
  let index = images.findIndex(image => image === variantImage.src);
  
  // If no exact match, try to find a partial match
  if (index === -1) {
    index = images.findIndex(image => variantImage.src.includes(image) || image.includes(variantImage.src));
  }

  return index;
}

function updateProductImage(variant) {
  const imageIndex = findVariantImageIndex(variant);
  if (window.productSplide && imageIndex !== -1) {
    window.productSplide.go(imageIndex);
    lastValidImageIndex = imageIndex;
  } else {
    console.log('No matching image found or Splide instance not available. Keeping current slide.');
    if (window.productSplide) {
      window.productSplide.go(lastValidImageIndex);
    }
  }
}

console.log('Cart JavaScript loaded');

// Contact Form Privacy Validation
document.addEventListener('DOMContentLoaded', function() {
  const contactForm = document.querySelector('form[action="/contact"]');
  if (contactForm) {
    const privacyCheckbox = contactForm.querySelector('input[name="contact[privacy_agreement]"]');
    const submitButton = contactForm.querySelector('#ContactFormSubmit');
    
    if (privacyCheckbox && submitButton) {
      contactForm.addEventListener('submit', function(e) {
        if (!privacyCheckbox.checked) {
          e.preventDefault();
          
          // Show error message
          let errorDiv = contactForm.querySelector('.privacy-error');
          if (!errorDiv) {
            errorDiv = document.createElement('div');
            errorDiv.className = 'alert alert-error privacy-error mt-2';
            errorDiv.innerHTML = '<strong>' + (document.documentElement.lang === 'de' ? 'Sie müssen der Datenschutzerklärung zustimmen.' : 'You must agree to the privacy policy.') + '</strong>';
            privacyCheckbox.closest('.form-checkbox').appendChild(errorDiv);
          }
          
          // Scroll to checkbox
          privacyCheckbox.scrollIntoView({ behavior: 'smooth', block: 'center' });
          
          return false;
        }
        
        // Remove error message if exists
        const errorDiv = contactForm.querySelector('.privacy-error');
        if (errorDiv) {
          errorDiv.remove();
        }
      });
      
      // Remove error when checkbox is checked
      privacyCheckbox.addEventListener('change', function() {
        if (this.checked) {
          const errorDiv = contactForm.querySelector('.privacy-error');
          if (errorDiv) {
            errorDiv.remove();
          }
        }
      });
    }
  }
});